module.exports = __webpack_public_path__ + "e2642563e888872351492d912294feda.woff2";